import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVideoTrim: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="video-trim"><path d="M15.25 2.75V4.75M15.25 4.75V19.25M15.25 4.75H2.75V19.25H15.25M15.25 19.25V21.25M18.75 19.25H21.25V4.75H18.75M8.25 12H8.75M7.5 9.75V14.25L10.5 12L7.5 9.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconVideoTrim;
